import request from '@/router/axios';

export const getTree = () => {
  return request({
    url: '/api/produce/base-device-camera-group/tree',
    method: 'get',
  });
};

export const addGroup = (row) => {
  return request({
    url: '/api/produce/base-device-camera-group/insert',
    method: 'post',
    data: row,
  });
};

export const removeGroup = (id) => {
  return request({
    url: '/api/produce/base-device-camera-group/delete/id',
    method: 'get',
    params: { id },
  });
};

export const getList = (params) => {
  return request({
    url: '/api/produce/base-device-camera/select/page',
    method: 'post',
    params,
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/produce/base-device-camera/select/id',
    method: 'get',
    params: { id },
  });
};

export const add = (row) => {
  return request({
    url: '/api/produce/base-device-camera/insert',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/produce/base-device-camera/update',
    method: 'post',
    data: row,
  });
};

export const remove = (id) => {
  return request({
    url: '/api/produce/base-device-camera/delete/id',
    method: 'get',
    params: { id },
  });
};

export const importExcel = (data) => {
  return request({
    url: '/api/produce/base-device-camera/import-excel',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
